
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.25.582v7a5.25 5.25 0 11-7.948-4.505L8.167.847v1.615L12.25.582zM7 4.665A2.917 2.917 0 107 10.5a2.917 2.917 0 000-5.834z","fill":"#910000"}})])
          )
        }
      }
    